<!--
=============================================================================
setera-web
=============================================================================
Copyright (c) 2026 HG Digital/Setera
Todos os direitos reservados.

Este software é confidencial e de propriedade da HG Digital/Setera.
Seu uso está sujeito aos termos do contrato de licença.
-----
Criado em : 2026-07-23 09:35:54
Autor : Diego Brock
Projeto : setera-web
Versão : 1.0.0
=============================================================================
-->
<div class="container-fluid">
  <mat-progress-bar mode="indeterminate" *ngIf="loader"></mat-progress-bar>

  <div *ngIf="errorMessage" class="alert alert-danger mt-2">
    {{ errorMessage }}
  </div>

  <div class="row no-gutters mt-3">
    <div class="mat-elevation table-content">
      <div fxLayout fxLayoutAlign="center center">
        <mat-form-field fxFlex="40%" class="ml-2">
          <mat-label>Filtrar comandos</mat-label>
          <input
            matInput
            autocomplete="off"
            (keyup)="applyFilter($event)"
            placeholder="Ex: GET_POSITION ou vídeo"
            #input
          />
        </mat-form-field>
      </div>

      <table mat-table [dataSource]="catalogo" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
          <td mat-cell *matCellDef="let element">{{ element.code }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
          <td mat-cell *matCellDef="let element">
            {{ element.description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="vincular">
          <th mat-header-cell *matHeaderCellDef class="mat-cell-vincular">
            <div [hidden]="hideMasterToggle || readOnly">
              <mat-slide-toggle
                (change)="onMasterToggleChange($event)"
                color="primary"
                [checked]="handleMasterToggle()"
                [disabled]="isVinculosDisabled()"
              >
              </mat-slide-toggle>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="mat-cell-vincular"
          >
            <mat-slide-toggle
              (change)="onCheckboxChange($event, element)"
              [checked]="hasVinculo(element)"
              color="primary"
              [disabled]="isVinculosDisabled()"
            >
            </mat-slide-toggle>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        [pageSizeOptions]="[10, 20, 40, 100]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</div>
